var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-manager",style:([ _vm.isEmpty ? {'display': 'none'}: '']),attrs:{"role":"dialog"}},[_vm._l((_vm.mountedModals),function(m){return [_c(m.modal,{key:m.id,ref:`modal_${m.id}`,refInFor:true,tag:"component"})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }